import { Equal, Plus, Minus, X, Divide01 } from "untitledui-js-base";

interface RoundedMathSymbolProps {
  symbol: string;
}

const Symbols = ({ symbol }: { symbol: string }) => {
  switch (symbol) {
    case "=":
      return <Equal size="14" />;
    case "+":
      return <Plus size="14" />;
    case "-":
      return <Minus size="14" />;
    case "X":
      return <X size="14" />;

    case "/":
      return <Divide01 size="14" />;
    default:
      return null;
  }
};

export const RoundedMathSymbol = ({ symbol }: RoundedMathSymbolProps) => {
  return (
    <div className="mr-2 shrink-0 md:mr-6 w-8 h-8 rounded-full border border-alpha-100 flex justify-center items-center">
      <Symbols symbol={symbol} />
    </div>
  );
};
